export type VoicePage = {
  number: string;
  chapterTitle: string;
  prompt: string;
};

export const voicePages: VoicePage[] = [
  {
    number: "01",
    chapterTitle: "Before I Left",
    prompt: "Describe home to someone who has never been there.",
  },
  {
    number: "02",
    chapterTitle: "Leaving",
    prompt: "Record the goodbye you wish you had said.",
  },
  {
    number: "03",
    chapterTitle: "The Day I Landed",
    prompt: "Tell the people back home what your first week was really like.",
  },
  {
    number: "04",
    chapterTitle: "The First Year",
    prompt: "Tell the story of your first year in five minutes or less.",
  },
  {
    number: "05",
    chapterTitle: "Work and Sacrifice",
    prompt: "Tell your family what your work here is really like.",
  },
  {
    number: "06",
    chapterTitle: "Far From Home",
    prompt: "Record something for someone you love back home: a greeting, a bedtime story, a song.",
  },
  {
    number: "07",
    chapterTitle: "Found Family",
    prompt: "Record a thank-you to someone who became family here.",
  },
  {
    number: "08",
    chapterTitle: "Taste of Home",
    prompt: "Walk someone through your favorite recipe from home, step by step.",
  },
  {
    number: "09",
    chapterTitle: "Hard Days",
    prompt: "Record a message for your future self to hear on a hard day.",
  },
  {
    number: "10",
    chapterTitle: "Home, Twice",
    prompt: "Record your answer to the question: Where is home?",
  },
  {
    number: "11",
    chapterTitle: "A Letter to My Future Self",
    prompt: "Read your letter out loud, so your future self can hear how you sounded today.",
  },
];

export function getVoicePage(number: string | undefined): VoicePage | undefined {
  return voicePages.find((page) => page.number === number);
}
